

export const FETCH_RESOLUTION_REQUEST = 'FETCH_RESOLUTION_REQUEST';
export const FETCH_RESOLUTION_REQUEST_COMPLETED = 'FETCH_RESOLUTION_REQUEST_COMPLETED';
export const FETCH_RESOLUTION_REQUEST_ERROR = 'FETCH_RESOLUTION_REQUEST_ERROR';
export const FETCH_RESOLUTION_RESET = 'FETCH_RESOLUTION_RESET';

export const FETCH_RESOLUTION_LIST_REQUEST = 'FETCH_RESOLUTION_LIST_REQUEST';
export const FETCH_RESOLUTION_LIST_REQUEST_COMPLETED = 'FETCH_RESOLUTION_LIST_REQUEST_COMPLETED';
export const FETCH_RESOLUTION_LIST_REQUEST_ERROR = 'FETCH_RESOLUTION_LIST_REQUEST_ERROR';
export const FETCH_RESOLUTION_LIST_RESET = 'FETCH_RESOLUTION_LIST_RESET';

export const FETCH_RESOLUTION_USER_LIST_REQUEST = 'FETCH_RESOLUTION_USER_LIST_REQUEST';
export const FETCH_RESOLUTION_USER_LIST_REQUEST_COMPLETED = 'FETCH_RESOLUTION_USER_LIST_REQUEST_COMPLETED';
export const FETCH_RESOLUTION_USER_LIST_REQUEST_ERROR = 'FETCH_RESOLUTION_USER_LIST_REQUEST_ERROR';

export const ADD_RESOLUTION_INITIAL = 'ADD_RESOLUTION_INITIAL';
export const ADD_RESOLUTION_REQUEST = 'ADD_RESOLUTION_REQUEST';
export const ADD_RESOLUTION_REQUEST_COMPLETED = 'ADD_RESOLUTION_REQUEST_COMPLETED';
export const ADD_RESOLUTION_REQUEST_ERROR = 'ADD_RESOLUTION_REQUEST_ERROR';

export const UPDATE_FILE_REQUEST = 'UPDATE_FILE_REQUEST';
export const UPDATE_FILE_REQUEST_COMPLETED = 'UPDATE_FILE_REQUEST_COMPLETED';
export const UPDATE_FILE_REQUEST_ERROR = 'UPDATE_FILE_REQUEST_ERROR';


// WEBPACK FOOTER //
// ./constants/resolutiondetails.js